export default class ArrayHelper {
    constructor () {
        throw 'Não é possível instanciar ArrayHelper'
    }

    static compareValues (key, order='asc') {
        return (a, b) => {
            if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
              // property doesn't exist on either object
                return 0; 
            }
        
            const varA = (typeof a[key] === 'string') ? 
                a[key].toUpperCase() : a[key];
            const varB = (typeof b[key] === 'string') ? 
                b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (
                (order == 'desc') ? (comparison * -1) : comparison
            );
        };
    }

    static agrupaArray (array, prop, sum) {
        let agrupado = []
        array.forEach(element => {
            if (!agrupado.find(item => item[prop] === element[prop])) {
                let obj = {[prop]: element[prop]}
                agrupado.push(obj)
            }
        })
        agrupado.forEach(element => {
            let valores = []
            valores = array.filter(item => item[prop] === element[prop])
            valores.reduce((prev, item) => element[sum] = prev + item[sum], 0)
        })
        return agrupado
    }

    static cloneArray (array) {
        let clonados = []
        array.forEach(elemento => {
            let elementoClonado = JSON.parse(JSON.stringify(elemento))
            clonados.push(elementoClonado)
        })
        return clonados
    }

    static distinctArray (array, atributo) {
        if (typeof atributo != 'string') {
            console.log('Atributo deve ser String e não', typeof atributo)
            return
        }
        let arrayLimpo = []
        array.forEach(element => {
            if(!arrayLimpo.some(item => item[atributo] === element[atributo])) {
                arrayLimpo.push(element)
            }
        })

        return arrayLimpo
    }

    static geraTamanhoLimitado (array, prop, tamanho) {
        array.map(item => {
            item.limitado = item[prop].substr(0, tamanho)
        })
    }
}


// WEBPACK FOOTER //
// ./src/helpers/ArrayHelper.js